import Row from '@amzn/meridian/row';
import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { IssueMap, requestTypeForPage } from '../../constants';
import { IAuthorizedReseller, IUser } from '../../redux/types';
import { color } from '../../theme/colors';
import { SiteMapPage } from '../../types';
import { useSiteMapRouter } from '../../utils/SiteMapRouter';
import { Link, useTranslation } from '../blocks';
import { CreateIssueModal } from './CreateIssueModal';

const FooterRow = styled(Row)`
    clear: both;
    position: relative;
    height: 2em;
    color: white;
    margin: auto;
    align-content: center;
    padding-top: 2rem;
    padding-bottom: 2rem;
    background-color: ${color.blue.muted[600]};
`;

export interface FooterProps {
    dataTestId?: string;
    user?: IUser;
    reseller?: IAuthorizedReseller;
    data?: any;
    stage?: string;
}

const Footer = ({ user, reseller, data, dataTestId }: FooterProps) => {
    const { t } = useTranslation('footer');
    const username = user?.username || t('unknownUsername');
    const resellerId = reseller?.resellerId || t('unknownResellerId');
    const { currentPage, goto } = useSiteMapRouter();
    const issueTemplate = IssueMap[currentPage];
    const params = new URLSearchParams(window.location.search);
    const showFeedback = params.get('showFeedback') === 'true';

    useEffect(() => {
        if (showFeedback) {
            const url = new URL(window.location.href);
            url.searchParams.delete('showFeedback');
            window.history.replaceState({}, '', url.toString());
        }
    }, [showFeedback]);

    return (
        <FooterRow alignmentHorizontal={'left'} spacing={'xlarge'} spacingInset={'medium'}>
            <Link
                type={'primary'}
                onClick={() => {
                    goto(SiteMapPage.helpPage);
                }}
            >
                {t('needHelp-link')}
            </Link>
            <CreateIssueModal
                header={t('requestAFeature-popoverHeader')}
                label={t('requestAFeature-link')}
                username={username}
                resellerId={resellerId}
                dataTestId={`${dataTestId}-requestFeaturePopover`}
                template={IssueMap['/footer/featureRequest']}
            />
            <CreateIssueModal
                header={t('createTroubleTicket-popoverHeader')}
                label={t('createTroubleTicket-link')}
                username={username}
                resellerId={resellerId}
                dataTestId={`${dataTestId}-createTroubleTicketPopover`}
                template={issueTemplate}
                pageData={data}
                showTypePicker={true}
                requestType={requestTypeForPage(currentPage)}
            />
            <CreateIssueModal
                header={t('sendFeedback-popoverHeader')}
                label={t('sendFeedback-link')}
                username={username}
                resellerId={resellerId}
                dataTestId={`${dataTestId}-sendFeedbackPopover`}
                template={IssueMap['/footer/feedback']}
                initialOpen={showFeedback}
            />
        </FooterRow>
    );
};

export { Footer };
